import styled from 'styled-components';
import { primary, neutral, error, white } from '../../style/colors';

const fadeIn = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const fadeInUp = `
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px;
  padding-bottom: 120px;

  @media (max-width: 768px) {
    padding: 20px;
    padding-bottom: 140px;
  }
`;

export const SectionNavBar = styled.div`
  position: sticky;
  top: 80px;
  background: ${white};
  border-bottom: 2px solid ${neutral[100]};
  margin-bottom: 30px;
  padding: 0 24px;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-radius: 12px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
    padding: 0 20px;
    top: 60px;
  }
`;

export const TwoColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 40% 1fr;
  gap: 40px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

export const ImageColumn = styled.div`
  @media (max-width: 1024px) {
    order: 2;
  }
`;

export const RelatedSection = styled.div`
  scroll-margin-top: 150px;
`;

export const ContentColumn = styled.div`
  @media (max-width: 1024px) {
    order: 1;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 40px 0;
`;

export const LoadingMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: ${primary[500]};
  font-weight: 600;
  padding: 20px;
  background: ${primary[50]};
  border-radius: 12px;
  border: 2px solid ${primary[200]};

  i {
    margin-right: 10px;
    font-size: 28px;
    color: ${primary[500]};
  }
`;

export const ErrorContainer = styled.div`
  ${fadeIn}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 16px;
  color: ${error.base};
  background: ${white};
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  animation: fadeIn 0.3s ease;
`;

export const ContentSection = styled.div`
  ${fadeInUp}
  background: ${white};
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  scroll-margin-top: 150px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
  animation: fadeInUp 0.4s ease backwards;
  animation-delay: ${(props) => props.delay || '0s'};

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
`;
